import _ from '../../utils/LodashImports';
import { formatNumberToPrice, getPriceToNumber, mapATGPricesToCatalystPrices } from '../../utils/PriceHelpers';

const getComboItemPrice = ({ prices, regionCode, toggles }) => {
  if (!prices || !prices.length) {
    return null;
  }
  const itemPrices = mapATGPricesToCatalystPrices(prices, regionCode, toggles);
  let itemPrice = itemPrices.filter((p) => p.type === 'internetPrice');
  if (itemPrice.length === 0) {
    itemPrice = itemPrices.filter((p) => p.type === 'normalPrice');
  }

  return itemPrice.length ? itemPrice : null;
};

const dispatchDDComboEvent = () => {
  const comboEventToDigitalData = new CustomEvent('DDCOMBOSPAGE');
  setTimeout(() => {
    window.dispatchEvent(comboEventToDigitalData);
  }, 2000);
};
const hasAtleastOneSpecification = ({ comboItems }) => {
  let hasSpecifications = false;
  comboItems.forEach((item) => {
    const specifications = _.get(item, 'product.attributes.specifications', null);
    if (specifications && specifications.length > 0) {
      hasSpecifications = true;
    }
  });
  return hasSpecifications;
};

const calculateTotalPrice = ({ comboItems, regionCode, toggles }) => {
  let totalPrice = 0;
  let nullFound = false;
  if (!comboItems || comboItems.length === 0) {
    return null;
  }
  const symbol = _.get(comboItems[0], 'product.prices[0].symbol', null);
  if (!symbol) {
    return null;
  }

  comboItems.forEach((item) => {
    const prices = _.get(item, 'product.prices');
    const quantity = _.get(item, 'quantity', 1);
    const normalPrice = getComboItemPrice({ prices, regionCode, toggles });
    const itemPrice = _.get(normalPrice, '[0].price[0]');
    if (!itemPrice) {
      nullFound = true;
      return;
    }
    totalPrice += getPriceToNumber(itemPrice, regionCode) * quantity;
  });

  if (nullFound) {
    return null;
  }

  return totalPrice;
};
const validateTotalPriceAmount = ({ totalPrice, variantData, regionCode }) => {
  const internetPriceObj =
    variantData?.prices?.find((price) => price.type === 'eventPrice') ??
    variantData?.prices?.find((price) => price.type === 'internetPrice');
  const internetPrice = internetPriceObj?.price?.[0];
  const [total, internet] = [totalPrice, internetPrice].map((price) => getPriceToNumber(price, regionCode));
  return total >= internet;
};
const constructComboData = ({ comboItems, bundleLinks, regionCode, toggles, variantData }) => {
  const productMap = new Map();

  comboItems.forEach((item) => {
    const { id, brand, displayName, prices, url, attributes, mediaUrls } = item.product;

    const totalQuantity = bundleLinks
      .filter((link) => link.id === id)
      .reduce((sum, link) => sum + (link.quantity || 1), 0);

    if (!totalQuantity || productMap.has(id)) {
      return;
    }

    productMap.set(id, {
      product: { id, brand, displayName, prices, url, attributes, mediaUrls },
      quantity: totalQuantity,
    });
  });

  const uniqueComboItems = Array.from(productMap.values());

  const totalPrice = calculateTotalPrice({
    comboItems: uniqueComboItems,
    regionCode,
    toggles,
  });
  if (!totalPrice) {
    return null;
  }
  const symbol = _.get(comboItems[0], 'product.prices[0].symbol', null);
  if (!symbol) {
    return null;
  }
  const formattedComboTotalPrice = formatNumberToPrice(totalPrice, regionCode);
  const comboData = {
    comboItems: uniqueComboItems,
    totalPrice: `${symbol}${formattedComboTotalPrice}`,
    showTotalPrice: validateTotalPriceAmount({
      totalPrice: formattedComboTotalPrice,
      variantData,
      regionCode,
    }),
    hasSpecifications: hasAtleastOneSpecification({
      comboItems: uniqueComboItems,
    }),
  };

  return comboData;
};

export {
  calculateTotalPrice,
  constructComboData,
  dispatchDDComboEvent,
  getComboItemPrice,
  hasAtleastOneSpecification,
  validateTotalPriceAmount,
};
